import React from "react";

import { useFormikContext } from "formik";
import { SourceEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";

import CustomTextInput from "./CustomTextInput";
import { default as MediaAndAutomationSettings } from "./MediaAndAutomationSettings";
import RssFeedUrlsInput from "./RssFeedUrlsInput";
import TopItems from "./TopItems";
import UploadMediaInput from "./UploadMediaInput";

const SOCIAL_MEDIA_PLATFORMS = [
  SourceEnum.INSTAGRAM_REELS,
  SourceEnum.YOUTUBE_SHORTS,
  SourceEnum.YOUTUBE_VIDEOS,
  SourceEnum.APPLE_PODCASTS,
];

export default function MediaSetup() {
  const { values } = useFormikContext<Partial<Template>>();

  if (!values?.sourceId) return null;

  return (
    <div>
      {SOCIAL_MEDIA_PLATFORMS.includes(values.sourceId) && (
        <MediaAndAutomationSettings />
      )}

      {values.sourceId === SourceEnum.RSS_FEEDS && <RssFeedUrlsInput />}
      {values.sourceId === SourceEnum.TEXT_BLOCK && <CustomTextInput />}
      {values.sourceId === SourceEnum.UPLOAD_MEDIA && <UploadMediaInput />}
      {values.sourceId === SourceEnum.TOP_ITEMS && <TopItems />}
    </div>
  );
}
